<template>
    <div class="ourAd">
      <div class="hotCarsTitle">
        <div class="hctMain clearfix">
          <div class="hctMainImg"><img :src="hctIcon" alt=""></div>
          <div class="hctMainTitle">我们的优势</div>
        </div>
      </div>
      <!--内容  -->
      <div class="ourAdMain">
          <ul>
            <li v-for="ourItem in our">
              <div class="oamImg"><img :src="ourItem.path" :alt="ourItem.title"></div>
              <div class="oamTitle clear">
                <!--<div class="oamTitleNumber">1</div>-->
                <div class="oamTitleMain">{{ourItem.title}}</div>
              </div>
              <div class="oamMain">
                <div class="oamMainText clearfix" v-for="ourItemItem in ourItem.content">
                  <p>
                    <van-icon name="star" color="#4d667e"/>
                    {{ourItemItem}}
                  </p>
                </div>
              </div>
            </li>
          </ul>
      </div>

    </div>
</template>

<script>
    export default {
        name: 'OurAd',
        data () {
            return {
              hctIcon:require("../../assets/icon_hotCar.png"),
              our:[
                {
                  path:require('../../assets/icon_ourAdBg01.png'),
                  title:'用车事宜找我们轻松搞定',
                  content:['我司专注带司机包车、自驾租车领域，公司拥有几十款车型满足您陪驾、自驾需求，一个电话轻松搞定，支持送车上门。'],
                },
                {
                  path:require('../../assets/icon_ourAdBg02.png'),
                  title:'行业经验丰富值得您信赖',
                  content:['我们承接大型会议、企业班车接送、旅游包车、自驾租车、商务会议考察接待，拥有行业十年操作经验，我们值得您信赖。'],
                },
                {
                  path:require('../../assets/icon_ourAdBg03.png'),
                  title:'轻松用车更多保障更安心',
                  content:['配驾车辆每部车座位险100万，自驾车辆第三责者保险100万，用车不满意提议后两个小时内给结果，让您用车无忧有保障'],
                },
                  {
                      path:require('../../assets/icon_ourAdBg01.png'),
                      title:'收费合理帮您省钱更实在',
                      content:['一价全包绝无欺诈收费有理有据，可根据需求开具发票、费用清单、合同协议，超要求用车减免部分费用，只为您再次与我们相约'],
                  },
                  {
                      path:require('../../assets/icon_ourAdBg02.png'),
                      title:'优秀陪驾司机出门更省心',
                      content:['选择我们陪驾服务，我们拥有一支优秀老司机队伍，他们熟悉本地交通、风土人情，他们遵守交通规则又性情温和让您旅游凭添喜悦。'],
                  },
                  {
                      path:require('../../assets/icon_ourAdBg03.png'),
                      title:'送车上门服务让您更少操心',
                      content:['公司拥有各种高中低档车型不同品牌供您挑选使用，您可到店查阅车辆亦可根据您的需求提供送车上门服务，您的满意是我们最大动力'],
                  },
              ],
              key:['index-our'],
              keyNumber:1
            }
        },
      mounted() {
          this.getImg();
      },
      methods:{
        getImg:function(){
          let str = '';
          if(this.keyNumber > 1){
            for (let i = 1;i <= this.keyNumber;i++){
              str += str ? ','+ (this.key[this.color] + (i < 10 ? '0'+i:i)) :(this.key[this.color] + (i < 10 ? '0'+i:i));
            }
          }else {
            for (let i = 0;i < this.key.length;i++){
              str += str ? ','+ this.key[i] : this.key[i];
            }
          }
          let that = this;
          this.axios.post('Getpicdb',
                  {
                    // viewType:'1',
                    pic_key:str
                  }).then(function (res) {
            console.log(res);
            let keyArr = str.split(',');
            if(keyArr.length > 1){
              for (let j = 0;j < keyArr.length;j++){
                if(res.data.data[keyArr[j]]){
                  that.our.push(res.data.data[keyArr[j]])
                }
              }
            }else {
              for(let index in res.data.data[keyArr[0]]){
                if(index < that.our.length){
                  that.our[index].path = res.data.data[keyArr[0]][index].path;
                  // that.our[index].title = res.data.data[keyArr[0]][index].title;
                }else {
                  res.data.data[keyArr[0]][index].content = [];
                  that.our.push(res.data.data[keyArr[0]][index]);
                }
              }
            }
          }).catch(function (err) {
            console.log(err);
          });
        },
      }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .clear {overflow: hidden;}
    .clearfix:before, .clearfix:after {clear: both;content: " ";display: table;}

    .hotCarsTitle{width: 100%;height: 60px;background: #f6f6f6}
    .hctMain{width: 340px;background: #2c3e50;background: linear-gradient(-45deg, transparent 45px, #2c3e50 0) bottom right;height: 60px; background-repeat: no-repeat;display: flex}
    .hctMainImg{display: flex;padding-left: 20px;box-sizing: border-box;align-items: center;height: 60px;}
    .hctMainImg img{width: 32px;height: 32px;vertical-align: middle}
    .hctMainTitle{display: flex;font-size:32px;font-family:PingFangSC-Semibold;font-weight:600;color:rgba(255,255,255,1);align-items: center;margin-left: 20px;}

    /*内容  */
    .ourAdMain{width: 700px;margin: 40px auto}
    .oamImg{width: 100%;height: 280px;}
    .oamImg img{width: 100%;height: 100%}
    .oamTitle{height: 96px;line-height: 96px;}
    .oamTitleMain{text-align: left;font-size:32px;font-family:PingFangSC-Medium;font-weight:500;color:rgba(44,62,80,1);}
    .oamMainText{margin-bottom: 24px}
    .oamMainText p{font-size:24px;font-family:PingFangSC-Regular;font-weight:400;color:rgba(77,102,126,1);text-align: left;float: left;margin: 0}
</style>

<style>
  .van-icon{float: left;font-size: 24px;display: flex;align-items: center;height: 100%;margin-right: 10px}
</style>



// WEBPACK FOOTER //
// src/components/OurAd/OurAd.vue